module.exports = {
	compareTwoStrings,
	findBestMatch
};

function compareTwoStrings (str1, str2) {
	if (!str1.length && !str2.length) return 1;                    // if both are empty strings
	if (!str1.length || !str2.length) return 0;                    // if only one is empty string
	if (str1.toUpperCase() === str2.toUpperCase()) return 1;       // identical
	if (str1.length === 1 && str2.length === 1) return 0;          // both are 1-letter strings

	const pairs1 = wordLetterPairs(str1);
	const pairs2 = wordLetterPairs(str2);
	const union = pairs1.length + pairs2.length;
	let intersection = 0;
	for (let [p, pLen] = [0, pairs1.length]; p < pLen; p++) {
		for (let i = 0, pair2; pair2 = pairs2[i]; i++) {
			if (pairs1[p] !== pair2) continue;
			intersection++;
			pairs2.splice(i, 1);
			break;
		}
	}
	return intersection * 2 / union;
}

function findBestMatch (mainString, targetStrings) {
	if (!areArgsValid(mainString, targetStrings)) throw new Error('Bad arguments: First argument should be a string, second should be an array of strings');
	let ratings = []
	for (let t = 0; t < targetStrings.length; t++) {
		ratings = ratings.concat({ target: targetStrings[t], rating: compareTwoStrings(mainString, targetStrings[t]) })
	}
	const bestMatch = Array.from(ratings).sort((a, b) => b.rating - a.rating)[0];
	return { ratings, bestMatch };
}

function flattenDeep (arr) {
	if (!Array.isArray(arr)) {
		return [arr];
	} else {
		let flattened = [];
		for (let i = 0; i < arr.length; ++i) {
			let current = arr[i];
			for (let j = 0; j < current.length; ++j)
				flattened = [...flattened, current[j]];
		}
		return flattened
	}
}

function areArgsValid (mainString, targetStrings) {
	if (typeof mainString !== 'string') return false;
	if (!Array.isArray(targetStrings)) return false;
	if (!targetStrings.length) return false;
	if (targetStrings.find(s => typeof s !== 'string')) return false;
	return true;
}

function letterPairs (str) {
	const pairs = [];
	for (let i = 0, max = str.length - 1; i < max; i++) pairs[i] = str.substring(i, i + 2);
	return pairs;
}

function wordLetterPairs (str) {
	let pairs = [];
	const strSplit = str.toUpperCase().split(' ');
	for (var s = 0; s < strSplit.length; s++) {
		pairs = pairs.concat(letterPairs(strSplit[s]))
	}
	return flattenDeep(pairs);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/string-similarity/compare-strings.js
// module id = gUOR
// module chunks = 13